import { render, staticRenderFns } from "./SsrSelectionBox.vue?vue&type=template&id=043318c2&scoped=true"
import script from "./SsrSelectionBox.vue?vue&type=script&lang=js"
export * from "./SsrSelectionBox.vue?vue&type=script&lang=js"
import style0 from "./SsrSelectionBox.vue?vue&type=style&index=0&id=043318c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043318c2",
  null
  
)

export default component.exports